import $ from "jquery";

import SettingActions from "../actions/SettingActions";

// TODO: BA-162 ensure unique test properties
const themes = [
	{ name: "cyborg", displayName: "Cyborg", testClass: "navbar-default", testProperty: "background-color", testValue: "rgb(6, 6, 6)" },
	{ name: "cerulean", displayName: "Cerulean", testClass: "navbar-default", testProperty: "background-color", testValue: "rgb(47, 164, 231)" },
	{ name: "cosmo", displayName: "Cosmo", testClass: "navbar-default", testProperty: "background-color", testValue: "rgb(34, 34, 34)" },
	{ name: "flatly", displayName: "Flatly", testClass: "navbar-default", testProperty: "background-color", testValue: "rgb(44, 62, 80)" },
	{ name: "journal", displayName: "Journal", testClass: "navbar-default", testProperty: "border-color", testValue: "rgb(238, 238, 238)" },
	{ name: "readable", displayName: "Readable", testClass: "navbar-default", testProperty: "border-color", testValue: "rgb(221, 221, 221)" },
	{ name: "slate", displayName: "Slate", testClass: "navbar-default", testProperty: "background-color", testValue: "rgb(58, 63, 68)" },
	{ name: "spacelab", displayName: "Spacelab", testClass: "navbar-default", testProperty: "background-color", testValue: "rgb(238, 238, 238)" }
];

// ThemeHelper
export default
{
	themes,

	setTheme(theme, initialize)
	{
		return new Promise((resolve, reject) =>
		{
			// See themes here: https://www.bootstrapcdn.com/bootswatch/
			// See example of theme selector here: https://wdtz.org/bootswatch-theme-selector.html
			const themeHref = `/css/themes/${theme.name}.min.css`;
			//$("link[title='main']").attr("href", theme);

			const $existingTheme = $("link[title='main']").first();
			const $styleSheet = $(`<link type="text/css" title="main" href="${themeHref}" rel="stylesheet" />`);
			$existingTheme.after($styleSheet);
			//$("head").append($styleSheet);

			$("meta[name='x-stylesheet-fallback-test']").attr("class", theme.testClass);

			let counter = 0;
			const intervalId = setInterval(() => {
				++counter;

				if (counter > 100)
				{
					console.error("couldn't cancel correctly, css might not be loaded");
					clearInterval(intervalId);
					reject("couldn't cancel correctly, css might not be loaded");
					return;
				}

				if (typeof($styleSheet[0].sheet) !== "undefined" && $styleSheet[0].sheet && !!$styleSheet[0].sheet.cssRules)
				{
					const metaElement = $("meta[name='x-stylesheet-fallback-test']")[0];
					const metaStyle = document.defaultView && document.defaultView.getComputedStyle
						? document.defaultView.getComputedStyle(metaElement)
						: metaElement.currentStyle;
					const styleValue = metaStyle[theme.testProperty];

					if (styleValue === theme.testValue)
					{
						$existingTheme.remove();
						clearInterval(intervalId);
						resolve();
					}
					// Style not correct, will try again since it may not be fully applied yet
					else
					{
						console.error(`style not correct: ${styleValue} !== ${theme.testValue}`);
					}
				}
				// Not yet loaded, will try again
				else
				{
					console.error("not loaded");
				}
			}, 10);

			if (!initialize)
			{
				SettingActions.updateUserProfile("Theme", theme.name);
			}
		});
	}
};



// WEBPACK FOOTER //
// ./Components/utils/ThemeHelper.jsx